export default __webpack_public_path__ + "static/media/LogoSunjad-dark.920f9ba2.svg";